import React from "react";
import pooja from "../img/Pooja_home.png";
import data from "../components/data";

const Aboutus = () => {
  const persons = data[0].person;
  return (
    <div className="container  mx-auto px-4">
      <div className="bg-gradient-to-r to-[#f59a61] from-[#f5695d] text-gray-100 rounded-3xl w-full overflow-hidden my-3">
        <div className="flex flex-col justify-center items-center w-full">
          <h1 className="pt-3">About us</h1>
          <div className="flex justify-center items-center">
            <div className="p-2">
              <p>
                <strong className="text-heading">
                  Shri Sai Bhakta Samaj :
                </strong>{" "}
                (Regd.) was established in October 1968 with its Regd. Office at
                27, Rajpur Road, Delhi being the residence of the then President
                Mr. R.S. Chitnis alongwith the following office bearers and
                members of Managing Committee with the noble objects to spread
                Baba's name/teaching amongst the public in General and devotees
                of Shri Sai Baba in particular, the spirit of universal
                brotherhood or religious toleration as embodied in Sai Bhakti,
                high principles of conduct and character without distinction of
                caste, creed and religion through mandir amongst other objects
                such as publishing magazines, periodicals, books etc. To promote
                and carry out services of all kinds which Holy SAI BABA had
                rendered to humanity. To establish libraries, regional centers,
                hospitals, Dharamshalas to help the poor and distressed to
                relieve human sufferings and improve standard of living and
                conduct. To promote unity among people belonging to different
                religions, caste and creed and work towards national integration
                with the following as office bearers and members of the 1st
                Managing Committee.
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center w-full h-40 overflow-scroll overflow-x-hidden bg-transparent">
            <ul>
              {persons.map((person) => {
                return (
                  <li className="flex text-gray-800 text-start pr-5 leading-6">
                    <p>{person.name}</p>
                    <p>{person.title}</p>
                  </li>
                );
              })}
              {/*<div className="flex  items-center">
                <li className="text-gray-800 text-start ml-5 leading-6">
                  <p>Sai Baba</p>
                </li>
                <li className="text-gray-800 text-start ml-5 leading-6">
                  <p>Sai Baba</p>
                </li>
              </div>
              <div className="flex  items-center">
                <li className="text-gray-800 text-start ml-5 leading-6">
                  <p>Sai Baba</p>
                </li>
                <li className="text-gray-800 text-start ml-5 leading-6">
                  <p>Sai Baba</p>
                </li>
              </div>
              <div className="flex  items-center">
                <li className="text-gray-800 text-start ml-5 leading-6">
                  <p>Sai Baba</p>
                </li>
                <li className="text-gray-800 text-start ml-5 leading-6">
                  <p>Sai Baba</p>
                </li>
            </div>*/}
            </ul>
          </div>
          <div className="flex justify-center items-center">
            <div className="w-32 p-2">
              <img src={pooja} alt="" className=" rounded-xl" />
            </div>
            <div className="p-2">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Quisquam voluptatum, quibusdam, quia, quos voluptates voluptatem
                quod dolorum voluptatibus quas quidem voluptate. Quisquam
                voluptatum, quibusdam, quia, quos voluptates voluptatem quod
                dolorum voluptatibus quas quidem
              </p>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Quisquam voluptatum, quibusdam, quia, quos voluptates voluptatem
                quod dolorum voluptatibus quas quidem voluptate. Quisquam
                voluptatum, quibusdam, quia, quos voluptates voluptatem quod
                dolorum voluptatibus quas quidem
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;

{
  /* Shri Sai Bhakta Samaj : (Regd.) was established in October 1968 with its Regd. Office at 27, Rajpur Road, Delhi being the residence of the then President Mr. R.S. Chitnis alongwith the following office bearers and members of Managing Committee with the noble objects to spread Baba's name/teaching amongst the public in General and devotees of Shri Sai Baba in particular, the spirit of universal brotherhood or religious toleration as embodied in Sai Bhakti, high principles of conduct and character without distinction of caste, creed and religion through mandir amongst other objects such as publishing magazines, periodicals, books etc. To promote and carry out services of all kinds which Holy SAI BABA had rendered to humanity. To establish libraries, regional centers, hospitals, Dharamshalas to help the poor and distressed to relieve human sufferings and improve standard of living and conduct. To promote unity among people belonging to different religions, caste and creed and work towards national integration with the following as office bearers and members of the 1st Managing Committee.
	Shri R.S. Chitnis	President
	Shri N.H. Kalgavakar	Vice President
	Shri K.B. Grover	Secretary
	Shri Siri Krishan Kapur	Jt. Secretary
	Shri Warman Varulkar	Treasurer
	Shri Krishan Mohan	Jt. Treasurer
Shri Sushil Kapoor, B.D. Kapoor, K.M. Bhatnagar, Mrs. Padamja R. Chitnis as members amongst some of the employees of Mr. R.S. Chitnis.

Efforts started to arrange land for constructing a Sai Memorial and with the grace & blessings of Lord SAI & sincere and continuous efforts by the office bearers & members were able to get 17,

Institutional Area, Lodhi Road, Plot from Land & Development office New Delhi for constructing, a Sai Memorial and this was the beginning of a dream of devotees coming true and this is the first Shirdi Sai Memorial in Northern India.

Shri Krishan Chand Dhawan, Shri Bhag Chand Taneja both businessmen came forward and joined hands to expedite the constructing of the memorial.

Shri R.S. Sharma, Shri S.C.Gupta, Shri M.M. Lal then also joined and all started to achieve the goal. Foundation stone laying ceremony was held in the month of August 1972. A souvenir was published on the auspicious occasion. It carried the messages of best wishes from a number of dignitaries including Hon'ble, President & Vice -President of India

M/s Pardhan Ghosh & Associates were consultant Architects who supervised the progress of the construction with all devotion and the building as we see today is a symbol of their and contractor's sincere and hard work mainly under the supervision of Mr. Chitnis.


Sh. Bhag Chand Taneja
The Statue of Lord SAI was now the first priority and efforts started in that direction. After consulting various sculptures it was decided to go to Jaipur. Shri R.S. Chitnis accompanied by Shri SiriKrishan Kapur & Shri S. C. Gupta visited Jaipur


Sh. S. K. Kapur	
M/s Rajasthan Murti Kala Kendra was selected to make the statue of Baba as per Shirdi Statue of white flawless marble of high quality. Shri Rameshwar Lal & Manohar Lal both brothers were the partners. Arrangements were made for their visit to Shirdi and a clay model was made during stay in Shirdi. The price of the Idol was agreed at as Rs.35,000/- and a sum of Rs, 5,000/- was paid as advance. We had to make a number of visits (say about 15) to Jaipur. The group comprised Shri R.S. Chitnis, Shri K.C. Dhawan, Shri R.S. Sharma, Shri S.C. Gupta, Shri Siri Krishan Kapur, Shri Sushil Kapur. A lot of efforts were put by all to see that the effect of Shirdi Statue could be brought. Shri R.S. Sharma and Shri S.C. Gupta were very particular in this regard.

At the time of taking the delivery full team went to Jaipur and came back S/Shri R.S. Sharma, Sushil Kapoor & Shri Pran Nath Verma an Income Tax Officer and a staunch devotee of Baba stayed behind and they accompanied the truck transporting the statue in a separate vehicle.

A team of South Indian Pandits arranged by Shri R.S. Sharma performed Havan & Puja for three days prior to the installation ceremony on 30.09.1976. This was a new experience as the performance of south Indian Pandits was befitting the occasion. Prior to the installation of the statue, painted picture of Baba sitting on stone, which is now installed in the Balcony, was kept for Puja in the hall. After establishment of the Samaj we, with a team of some employees of Mr. Chitnis who had formed a Qawalls group and used to sing Qawalies & Sai Bhajans; on behalf of Samaj used to arrange Bhajans at the houses of members and others devotees and the offering collected were credited to Samaj account for construction of the memorial building.


Sh. K.C. Dhawan
Mr. Chitnis used to collect donations from distributors of the films who wanted to screen their films at both cinema houses and the donations so collected were also credited to the Samaj account to be used for construction

For a long time every Thursday Pooja, Aarti and Bhajans were conducted at the residence of Shri B.D. Kapoor where Mr. Chitnis also used to join regularly. This was the aim of all of us to collect funds for the purpose. Donations collected by all the members were for this purpose and Mr. Chitnis used to issue monthly report giving details of the funds collected by each member.

It may also be mentioned that with a view to protect the devotees from sun & rain. Fiber glass sheds were erected. Unfortunately due to accidental fire on 5/6/2002, the sheds were burnt and the sheds as we see now are excellent one and non-combustible. Mercury lights have been fixed which give an excellent view

After the fire incident devotees have come forward in numbers and offered donation in cash and kind liberally for renovation of the building. */
}
